import { Button, Card, Form, Input, Modal, Select } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";

import commonLookupService from "../../../services/commonLookupService";
import financialYearService from "../../../services/finYearService";
import api from "../../../services/nysProgrammeService";
import { recordError } from "../../../utils/logService";

import { util } from '@seims/shared';

export default function ViewNYSProgramme(props) {
  const [disabled, setDisabled] = useState(true);
  const [titles, setTitles] = useState([]);
  const [currentFinYear, setCurrentFinYear] = useState("");
  const defaultDate = moment().format("YYYY-MM-DD");
  const [closingDate, setClosingDate] = useState(defaultDate);

  useEffect(() => {
    getClosingDate();
    onFormLoad();
    loadTitles();
    loadFinancialYears();
    // getClosingDate();
  }, [props.record]);

  const [form] = Form.useForm();
  const { Option } = Select;
  const formName = "ViewNYSProgramme";

  const Confirm = () => {
    props.onShow(false);
    setDisabled(true);
  };

  const getClosingDate = async () => {
    let msg;
    var searchDate;
    var { endDate, startDate } = props.record;
    endDate = moment(endDate).format("YYYY-MM-DD");
    startDate = moment(startDate).format("YYYY-MM-DD");

    // This is for cases where the enddate is greater than the current date
    // In such cases the system will not be able to find finyear because enddate is used as an upper bound for retrieving the finyear
    // We there use the start date which would act as a lower bound for the rtrieval of financial year details
    if (endDate > defaultDate) searchDate = startDate;
    else searchDate = endDate;

    try {
      const response = await api.getClosingDate(searchDate);

      if (response && (response.status == 200 || response.status == 201)) {
        const { data } = response;
        const midNightClosing = moment(endDate).endOf("day");
        setClosingDate(midNightClosing);
      }
    } catch (error) {
      //   if (error && error?.response?.status == 404) {
      //     msg = util.parseMessage(Messages.CLOSING_DATE, "Closing date");
      //     openNotification("Closing date", msg, Notify.ERROR);
      //     recordError(error);
      //     return;
      //   }
      //   msg = util.parseMessage(Messages.CLOSING_DATE, "Closing date");
      //   openNotification("Closing date", msg, Notify.ERROR);
      //   recordError(error);
    }
  };

  const loadTitles = async () => {
    try {
      const response = await commonLookupService.getTitles();
      if (response) {
        const { data } = response;

        setTitles(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const loadFinancialYears = async () => {
    try {
      const response = await financialYearService.getAllFinYears();
      if (response) {
        const { data } = response;

        setCurrentFinYear(data.find((c) => c.active == true));
      }
    } catch (error) {
      recordError(error);
    }
  };

  const onFormLoad = () => {
    const data = props.record;

    const {
      id,
      name,
      description,
      financialYear,
      startDate,
      endDate,
      contactName,
      surname,
      title_id,
      email,
      contactNumbers,
    } = data;

    if (!util.isEmpty(data)) {
      var contactNo = data.contactNumbers?.toString().replaceAll(",", ", ");

      form.setFieldsValue({
        id: data.id,
        name: data.name,
        description: data.description,

        financialYear: data.financialYear,
        startDate: data.startDate,
        endDate: data.endDate,

        contactName: data.contactName,
        surname: data.surname,
        title_id: data.title_id,
        email: data.email,
        contactNumbers: contactNo,
      });
    }
  };

  return (
    <>
      <Modal
        forceRender
        title="View NYS Programme Details"
        key="nys-modal-add"
        open={props.visible}
        closable={false}
        keyboard={false}
        maskClosable={false}
        width={900}
        footer={[
          <div className="modal-footer-buttons">
            <Button onClick={() => Confirm()}>Okay</Button>
          </div>,
        ]}
      >
        <Form
          disabled={true}
          labelCol={{
            span: 4,
          }}
          wrapperCol={{
            span: 18,
          }}
          form={form}
          name={formName}
          // onFinish={updateProgramme}
        >
          <h4 key="nys-programme">
            <br />
            <br />
            {/* <b>Current Financial Year <Tag color="blue">{currentFinYear?.shortValue}</Tag></b><br/><br/> */}
            <b>NYS Programme </b>
            <br />
          </h4>
          <Card key="nys-card-programme">
            <Form.Item hidden={true} name="id" label="id">
              <Input name="id" />
            </Form.Item>
            <Form.Item
              name="name"
              label="Name"
              rules={[
                {
                  required: true,
                  message: "Please provide NYS programme name",
                },
              ]}
            >
              <Input name="name" />
            </Form.Item>
            <Form.Item
              name="description"
              label="Description"
              rules={[
                {
                  required: true,
                  message: "Please provide NYS programme description",
                },
              ]}
            >
              <Input name="description" />
            </Form.Item>
            <Form.Item name="startDate" label="Opening Date">
              <Input />
            </Form.Item>
            <Form.Item name="endDate" label="Closing Date">
              <Input />
            </Form.Item>
            <Form.Item name="financialYear" label="Financial Year">
              <Input disabled={true} />
            </Form.Item>

            {/* {closingDate && (
              <h3 style={{}}>
                Applications closing on{" "}
                <Tag color="blue">{moment(closingDate).format("LLLL")}</Tag>
              </h3>
            )} */}
          </Card>
          <h4 key="nys-contact">
            <b>Contact Person</b>
          </h4>
          <Card key="nys-contact-details">
            <Form.Item
              name="contactName"
              label="Name"
              rules={[
                {
                  required: true,
                  message: "Please provide a valid name",
                },
              ]}
            >
              <Input name="contactName" />
            </Form.Item>
            <Form.Item
              name="surname"
              label="Surname"
              rules={[
                {
                  required: true,
                  message: "Please select a valid surname",
                },
              ]}
            >
              <Input name="surname" />
            </Form.Item>
            <Form.Item
              name="title_id"
              label="Title"
              rules={[
                {
                  required: true,
                  message: "Please select a valid title",
                },
              ]}
            >
              <Select allowClear placeholder="Please select">
                {titles.map((title) => {
                  return (
                    <Option key={title.key} value={title.key}>
                      {title.value}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              name="email"
              label="Email Address"
              rules={[
                {
                  type: "email",
                  message: "The input is not valid E-mail",
                },
                {
                  required: true,
                  message: "Please provide valid email",
                },
              ]}
            >
              <Input name="email" />
            </Form.Item>
            <Form.Item name="contactNumbers" label="Contact Numbers">
              <Input name="contactNumbers" />
            </Form.Item>
            {/* <DynamicField /> */}
          </Card>
        </Form>
      </Modal>
    </>
  );
}
